<template>
  <!-- <v-layout>
      <h1>Fixed Cost #{{$route.params.id}}</h1>
  </v-layout>-->
  <v-layout pl-2 pt-2 pr-2 pb-2 justify-start row>
    <div style="width: 180px;">
      <SimpleCard>
        <BookingSearchBox @search="search" @clear="clear" :query="query"></BookingSearchBox>
      </SimpleCard>
      <v-flex mt-2>
        <SimpleCard>
          <v-flex pa-1 shrink>
            <v-btn
              small
              target="_blank"
              href="/backdate"
              color="blue"
              dark
              class="text-none"
            >Backdate Trip</v-btn>
          </v-flex>
        </SimpleCard>
      </v-flex>
    </div>
    <div style="width: calc(100% - 180px)">
      <div style="padding-left: 12px;">
        <SimpleCard>
          <v-layout row wrap align-content-center justify-center>
            <v-flex v-if="loading" xs12 pa-2 class="text-xs-center">
              <v-progress-circular :size="48" :width="5" color="primary" indeterminate></v-progress-circular>
            </v-flex>
            <v-row align="center" justify="end">
              <v-icon :size="16">help</v-icon>
              <p style="font-size: 11px;">You can preassign a driver by clicking the driver cell.</p>
            </v-row>
            <BookingSummaryList
              v-if="!loading"
              style="width: 100%;"
              :bookings="bookings"
              :paginationProp="pagination"
              :rideTypes="rideTypes"
              @reload="getBookings"
            ></BookingSummaryList>
            <v-flex v-if="!loading" pt-2 xs9 class="text-xs-center pt-2">
              <v-pagination @input="changePage" v-model="pagination.page" :length="num_pages"></v-pagination>
            </v-flex>
          </v-layout>
        </SimpleCard>
      </div>
    </div>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import BookingSummaryList from "@/components/booking/BookingSummaryList.vue";
import BookingSearchBox from "@/components/booking/BookingSearchBox.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

import moment from "moment";

export default {
  name: "bookings",
  components: {
    SimpleCard,
    BookingSummaryList,
    BookingSearchBox
  },

  data: function() {
    return {
      bookings: [],
      offset: 0,
      count: 20,
      query: {
        state: "booked",
        name: "",
        number: "",
        pickup: "",
        destination: "",
        before: "",
        after: "",
        paymentType: "all",
        bookingMethod: "all",
        refNum: "",
        bookingID: null,
        hideRepeatTrips: false
      },
      loading: true,
      pagination: { page: 1 },
      num_pages: 0,
      rideTypes: []
    };
  },
  mounted: async function() {
    if (this.$route.query.bookingID) {
      this.query.bookingID = this.$route.query.bookingID;
      this.query.before = "";
      this.query.state = "all";
    }

    if (this.$route.query.contact_number) {
      this.query.number = this.$route.query.contact_number;
      this.query.before = "";
      this.query.state = "all";
    }

    if (this.$route.query.name) {
      this.query.name = this.$route.query.name;
      this.query.before = "";
      this.query.state = "all";
    }

    this.getBookings();
    this.getRideTypes();
  },
  methods: {
    search: function() {
      this.pagination.page = 1;
      this.getBookings();
    },
    clear: function() {
      this.query = {
        state: "all",
        name: "",
        number: "",
        pickup: "",
        destination: "",
        before: "",
        after: "",
        paymentType: "all",
        bookingMethod: "all",
        refNum: "",
        bookingID: null
      };
    },
    changePage: function(page) {
      this.pagination.page = page;
      console.log(page);
      this.getBookings();
    },
    getBookings: async function() {
      this.loading = true;

      try {
        var url;

        // if (this.query.bookingID == null || this.query.bookingID == "") {
        url = `${this.$store.state.apiUrl}/booking/list?offset=${this.count *
          (this.pagination.page - 1)}&count=${this.count}&state=${
          this.query.state
        }&name=${
          this.query.name
        }&number=${this.query.number.trim()}&paymentType=${
          this.query.paymentType
        }&bookingMethod=${this.query.bookingMethod}&before=${
          this.query.before
        }&after=${this.query.after}&hideRepeatTrips=${
          this.query.hideRepeatTrips
        }`;

        if (this.query.refNum != null && this.query.refNum != "") {
          url += `&refNum=${this.query.refNum}`;
        }

        // if (this.query.bookingID != null && this.query.bookingID != "") {
        //   url += `&bookingID=${this.query.bookingID}`;
        // }

        if (this.query.pickup != null && this.query.pickup != "") {
          url += `&pickup=${this.query.pickup}`;
        }

        if (this.query.destination != null && this.query.destination != "") {
          url += `&destination=${this.query.destination}`;
        }

        if (this.query.bookingID != null && this.query.bookingID != "") {
          url += `&bookingID=${this.query.bookingID}`;
        }
        // }

        let response = await axios.get(url, {
          params: {}
        });

        var bookings = response.data.bookings;

        this.bookings = bookings;

        this.pagination.page = response.data.pages.page;
        this.num_pages = response.data.pages.num_pages;

        console.log(response.data.num_pages);

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get bookings " + error);
      }
    },
    getRideTypes: async function() {
      try {
        var url = `${this.$store.state.apiUrl}/ride_types/all`;

        let response = await axios.get(url, {
          params: {}
        });

        this.rideTypes = response.data;

        this.getRepeatService();

        console.log("got ride types");
      } catch (error) {
        this.loading = false;
        console.log("Failed to get ride types " + error);
      }
    },
    failed: function(data) {
      alert("Request Failed with error: " + data.message);
    }
  }
};
</script>
